/**
 * @generated SignedSource<<ccaed0bf8563d877e2ea02e2a899caec>>
 * @relayHash cfed55ff624a173780e0ef51bccfee86
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID cfed55ff624a173780e0ef51bccfee86

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "region"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "region",
        "variableName": "region"
      }
    ],
    "concreteType": "Account",
    "kind": "LinkedField",
    "name": "managers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountExtra",
        "kind": "LinkedField",
        "name": "extra",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastname",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectManagerQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SelectManagerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "cfed55ff624a173780e0ef51bccfee86",
    "metadata": {},
    "name": "SelectManagerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "604fee904867a2bdc4c84797d91dc87f";

export default node;
